import { useDispatch, useSelector } from 'react-redux';
import { Container, Surface } from '@vst/beam';

import {
  AnalyticsEventNames,
  Categories,
  DataLayerEventName,
  pushToAdobeDataLayer,
} from '@app/services/adobeDataLayer';
import { addPlanToCart, selectChangePlan, setConsentChecked } from '@app/redux/changePlan';

import { GetPlanOffersPayload } from '@mfe/shared/schema-types';

import Loading from '../Loading';
import AvailablePlan from './AvailablePlan';
import BroadbandLabel from './BroadbandLabel';

import styles from './styles.module.scss';

const AvailablePlans = () => {
  const dispatch = useDispatch();

  const loadingCards = [{ name: '-' }, { name: '-' }];
  const { planOffersData, loading } = useSelector(selectChangePlan);

  if (!planOffersData && !loading) {
    return null;
  }

  return (
    <Surface variant="secondary" className={styles['gridSurface']} data-cy="available-plans">
      <Container
        fluid
        className={styles['gridContainer']}
        style={{
          justifyItems: 'center',
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        {loading ? (
          <Loading cards={loadingCards} />
        ) : (
          planOffersData?.map((plan: GetPlanOffersPayload, i: number) => (
            <AvailablePlan
              plan={plan}
              broadbandLabel={<BroadbandLabel plan={plan} />}
              key={`plan-${i}`}
              handleClick={() => {
                dispatch(addPlanToCart({ newProductTypeId: plan.id }));
                dispatch(setConsentChecked(false));

                pushToAdobeDataLayer({
                  event: DataLayerEventName.PAGE_VIEW,
                  event_name: DataLayerEventName.PAGE_VIEW,
                  event_label: `${AnalyticsEventNames.ChangePlanSelected} | Selected plan: ${plan.characteristics.offerName}`,
                  event_category: Categories.ChangePlan,
                });
              }}
            />
          ))
        )}
      </Container>
    </Surface>
  );
};

export default AvailablePlans;
